import { mapServerToProductBase } from "./map-server-to-product-base.js";
import { mapServerToAccessoriesVariant } from "../../../../variant-mappers/mappers/server-to-client/variant-mappers/map-server-to-accessories-variant.js";
const mapServerToAccessoriesProduct = (serverProduct, slug, locale, facetConfigList, flatFacetConfigList, priceSegmentChannelKey) => {
  if (serverProduct?.__typename !== "AccessoriesProduct") {
    return {
      failure: "incorrect-typename",
      message: `Expected AccessoriesProduct for slug "${slug}", but got ${serverProduct?.__typename}`
    };
  }
  const variants = mapServerToAccessoriesVariant(
    serverProduct,
    slug,
    locale,
    priceSegmentChannelKey
  );
  if (!variants || variants.length === 0) {
    return {
      failure: "no-variants",
      message: `Cannot return Accessories product with slug: "${slug}" because it has no variants`
    };
  }
  return {
    ...mapServerToProductBase(serverProduct, variants, facetConfigList, flatFacetConfigList),
    productType: "Accessories",
    variants
  };
};
export {
  mapServerToAccessoriesProduct
};
//# sourceMappingURL=map-server-to-accessories-product.js.map
